export class CurrenciesNotCompatible extends Error {
    constructor(...currencies) {
        super('Currencies are not compatible');
        this.currencies = currencies;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
